function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M478.6,206.9c13.1,77.6-28,151.8-102.3,188.2c11.8,30.8-11.2,63.5-43.7,63.5c-24.8,0-45.3-19.5-46.6-44.3 c-5.8,0.2-58,0-69-0.6c-1,25.8-22.8,45.8-48.6,44.8c0,0,0,0,0,0c-30.6-1.2-52.4-31.5-42.5-61.4c-33.6-11.9-65.6-31.5-90.1-64 c-11.8-15.6-0.4-37.8,18.8-37.8c41.9,0,29.1-49,39-99.7C110.3,110.6,199.2,53.5,285,53.5C377.7,53.5,463.3,117.4,478.6,206.9 L478.6,206.9z M362.3,375.6c38-17.3,73.5-51.3,87.1-92.3C485.9,172,391.3,77.1,285,77.1c-75.4,0-154,50.1-168.2,123 c-8.6,44.2,4.5,118.7-62.2,118.7c22.5,29.9,52.7,47.6,84.7,57.9c22.3-19.7,57.7-14,72.2,13c12.9,0.9,71.6,1.1,79.5,0.7 c11.8-23,39.9-32.1,62.9-20.3C356.9,371.6,359.7,373.5,362.3,375.6z M210,193.7c0-31.4,46-31.4,46,0S210,225.1,210,193.7z  M315.4,193.7c0-31.4,46-31.4,46,0S315.4,225.2,315.4,193.7z M204.6,257.6c-3.1-15.3,20.1-20.1,23.2-4.7l0.1,0.3 c3.7,19.4,27,39.8,58,38.9c32.3-0.8,53.6-20.1,58-38.7c4-14.5,25.9-9.4,23,5.4c-4.7,20.1-28.2,56.1-82.7,56.9 C245.6,315.7,210.9,290.6,204.6,257.6L204.6,257.6z"
}));

var SvgWaze = function SvgWaze(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaze, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waze.6aef0f69.svg";
export { ForwardRef as ReactComponent };